// extracted by mini-css-extract-plugin
export default {"rating":"OG-z","numberOfStars":"PG-z","count":"QG-z","barGraphSpacing":"RG-z","barGraph":"SG-z"};